/**
 * Retrieves the search portion of the current URL.
 * @returns {string} The search portion of the URL.
 */
export function getLocationSearch() {
  return window.location.search;
}

/**
 * Returns the current URL href of the page.
 * @returns {string} The current URL of the page.
 */
export function getLocationHref() {
  return window.location.href;
}

/**
 * Returns the host of the current location.
 * @returns {string} The host of the current location.
 */
export function getLocationHost() {
  return window.location.host;
}
